import { type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesDialog = (): ComponentsOverrides['MuiDialog'] => ({
  paperScrollPaper: {
    overflowY: 'hidden',
  },
})

export const overridesDialogContent = (): ComponentsOverrides['MuiDialogContent'] => ({
  root: {
    padding: 0,
  },
})

export const overridesDialogActions = (theme: Theme): ComponentsOverrides['MuiDialogActions'] => ({
  root: {
    backgroundColor: theme.customPalette.background.default,
    justifyContent: 'center',
  },
})
